import { stringify as stringifyQs } from "qs";
import urljoin from "url-join";
import urlJoin from "url-join";

import {
  ActiveTab,
  Dialog,
  Filters,
  // FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";

const brandsSection = "/brands/";

export const brandsSectionPath = brandsSection;

export const brandsListPath = (id: string) => urlJoin(brandsSectionPath, id);

export enum BrandGroupsUrlFiltersEnum {
  query = "query",
  vertical = "vertical",
  classification = "classification",
  isSmacAffiliate = "isSmacAffiliate"
}

// export enum BrandGroupsUrlFiltersWithMultipleValues {
//   tags = "tags",
//   status = "status"
// }

export enum BrandGroupListUrlSortField {
  direction = "direction",
  field = "field"
}

export type BrandGroupsUrlDialog = TabActionDialog | "delete";

export type BrandGroupsListUrlFilters = Filters<BrandGroupsUrlFiltersEnum>;
// &
//   FiltersWithMultipleValues<BrandGroupsUrlFiltersWithMultipleValues>;

export type BrandGroupListUrlSort = Sort<BrandGroupListUrlSortField>;
export type BrandsUrlQueryParams = Pagination &
  BrandGroupListUrlSort &
  BrandGroupsListUrlFilters &
  ActiveTab &
  Dialog<BrandGroupsUrlDialog>;
export const brandsListUrl = (params?: BrandsUrlQueryParams) =>
  brandsSectionPath + "?" + stringifyQs(params);

export const brandsUrl = (id: string, params?: BrandsUrlQueryParams) =>
  brandsListPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const brandsPath = (id: string) => urljoin(brandsSection, id);

export type BrandGroupsQueryParams = Dialog<BrandGroupsUrlDialog>;
